import React from 'react'
import { Amplify, Auth } from "aws-amplify";
import { setAdmin, useAppDispatch } from '../store'
import { useNavigate } from 'react-router-dom'

var authConfig = {
    // @ts-ignore
    region: window.AWS_COGNITO_REGION,
    // @ts-ignore        
    userPoolId: window.AWS_COGNITO_USER_POOL_ID,
    // @ts-ignore        
    userPoolWebClientId: window.AWS_COGNITO_CLIENT_ID
}

Amplify.configure({
    Auth: authConfig
});

export type CognitoAuthProviderType = {
    loaded: boolean;
    user: any;
    signin: (username: string, password: string) => void;
    signout: () => void;
}

// @ts-ignore
let AuthContext = React.createContext<CognitoAuthProviderType>(null);

const AuthProvider = ({ children }: { children: React.ReactNode }) => {

    let [loaded, setLoaded] = React.useState(false)
    let [user, setUser] = React.useState<any>(null);
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    React.useEffect(() => {
        checkForSignedInUser()
    }, [])

    const checkForSignedInUser = async () => {
        try {
            let user = await Auth.currentAuthenticatedUser()
            handleUser(user)
            navigate('/')
        } catch (error) { }
        finally {
            setLoaded(true)
        }
    }

    const handleUser = (user: any) => {
        const isAdmin = user.signInUserSession.accessToken.payload["cognito:groups"]?.indexOf('Admin') > -1
        dispatch(setAdmin(isAdmin))
        setUser(user)
    }

    let signin = async (username: string, password: string) => {
        let creds = { username, password }
        let user = await Auth.signIn(creds)
        handleUser(user)
    };

    let signout = async () => {
        await Auth.signOut()
        setUser(null)
    };

    let value = { loaded, user, signin, signout };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

/**
 * Load the AuthProvider
 * @returns CognitoAuthProviderType
 */
export const useAuth = () => {
    return React.useContext(AuthContext);
}

export default AuthProvider